import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom'
import { AppShell } from './components/AppShell'
import { ErrorFallback } from './components/ErrorFallback'
import { RequireAuth } from './components/RequireAuth'
import { LoginPage } from './pages/LoginPage'
import { RecoverPage } from './pages/RecoverPage'
import { ChangePasswordPage } from './pages/ChangePasswordPage'
import { HomePage } from './pages/HomePage'
import { TabletsPage } from './pages/TabletsPage'
import { DataSetsPage } from './pages/DataSetsPage'
import { DataSetDetailPage } from './pages/DataSetDetailPage'
import { NewSchemaPage, SchemaVersionsPage, SchemasListPage } from './pages/SchemasPage'
import { UsersPage } from './pages/UsersPage'
import { DecodeLabelPage } from './pages/DecodeLabelPage'

const router = createBrowserRouter([
  { path: '/login', element: <LoginPage />, errorElement: <ErrorFallback /> },
  { path: '/recover', element: <RecoverPage />, errorElement: <ErrorFallback /> },
  { path: '/recover/:token', element: <RecoverPage />, errorElement: <ErrorFallback /> },
  {
    path: '/change-password',
    element: (
      <RequireAuth>
        <ChangePasswordPage />
      </RequireAuth>
    ),
    errorElement: <ErrorFallback />,
  },
  {
    path: '/',
    element: (
      <RequireAuth>
        <AppShell />
      </RequireAuth>
    ),
    errorElement: <ErrorFallback />,
    children: [
      { index: true, element: <HomePage /> },
      {
        path: 'tablets',
        element: (
          <RequireAuth roles={['admin', 'developer']}>
            <TabletsPage />
          </RequireAuth>
        ),
      },
      { path: 'data-sets', element: <DataSetsPage /> },
      { path: 'data-sets/:id', element: <DataSetDetailPage /> },
      {
        path: 'schemas',
        element: (
          <RequireAuth role="developer">
            <SchemasListPage />
          </RequireAuth>
        ),
      },
      {
        path: 'schemas/new',
        element: (
          <RequireAuth role="developer">
            <NewSchemaPage />
          </RequireAuth>
        ),
      },
      {
        path: 'schemas/:name',
        element: (
          <RequireAuth role="developer">
            <SchemaVersionsPage />
          </RequireAuth>
        ),
      },
      {
        path: 'users',
        element: (
          <RequireAuth roles={['admin', 'developer']}>
            <UsersPage />
          </RequireAuth>
        ),
      },
      { path: 'decode-label', element: <DecodeLabelPage /> },
      // Keep the old `/visualize` URL working for any printed labels / links
      // minted before the rename.
      { path: 'visualize', element: <Navigate to="/decode-label" replace /> },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
])

export function Router() {
  return <RouterProvider router={router} />
}
